export class User {
  constructor(data) {
    Object.assign(this, data);
  }
}
